import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spacing from '../Spacing';
import PromoRibbon from './PromoRibbon';
import { BodySecondary, SubtitlePrimary } from '../Base';

const StyledDescription = styled(BodySecondary)`
  color: ${p => p.theme.colours.grey_600};
`;

const PromoContent = props => {
  const { title, subtitle, description } = props;

  return (
    <Fragment>
      <Spacing bottom={2}>
        <PromoRibbon>{title}</PromoRibbon>
      </Spacing>
      <SubtitlePrimary>{subtitle}</SubtitlePrimary>
      <Spacing bottom={2}>
        <StyledDescription>{description}</StyledDescription>
      </Spacing>
    </Fragment>
  );
};

PromoContent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string
};

export default PromoContent;
